module.exports = __webpack_public_path__ + "img/rise.97ec478.webp";